import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Eye, Search, Undo2 } from 'lucide-react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogTitle } from './ui/dialog';
import { useAuth } from '../contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ImpersonateDialog = ({ open, onClose }) => {
  const { impersonate } = useAuth();
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState('');
  useEffect(() => {
    if (!open) return;
    setQ('');
    axios.get(`${API}/admin/impersonate/users`, { headers: { Authorization: `Bearer ${localStorage.getItem('capex_token')}` } })
      .then(r => setUsers(r.data)).catch(e => toast.error(e.response?.data?.detail || 'Erreur'));
  }, [open]);
  const go = async (u) => { try { await impersonate(u.id); } catch (e) { toast.error(e.response?.data?.detail || 'Erreur'); } };
  const rows = users.filter(u => `${u.name} ${u.email} ${u.role}`.toLowerCase().includes(q.trim().toLowerCase()));
  return (
    <Dialog open={open} onOpenChange={v => !v && onClose()}>
      <DialogContent className="max-w-lg" data-testid="impersonate-dialog">
        <DialogTitle>Voir l'application comme…</DialogTitle>
        <p className="text-sm text-slate-500 -mt-1">Vous naviguez avec ses droits et pouvez agir à sa place (session de 2 h). Un bandeau permet de revenir à votre compte.</p>
        <div className="relative"><Search className="absolute left-2.5 top-2.5 h-4 w-4 text-slate-400" />
          <input autoFocus className="w-full rounded-lg border border-slate-300 py-2 pl-8 pr-3 text-sm" placeholder="Rechercher un utilisateur…" value={q} onChange={e => setQ(e.target.value)} data-testid="impersonate-search" /></div>
        <div className="max-h-80 overflow-y-auto divide-y rounded-lg border">
          {rows.map(u => (
            <button key={u.id} type="button" onClick={() => go(u)} className="flex w-full items-center gap-3 px-3 py-2 text-left text-sm hover:bg-orange-50" data-testid={`impersonate-user-${u.id}`}>
              <span className="font-semibold">{u.name}</span><span className="text-xs text-slate-500">{u.email}</span>
              <span className="ml-auto rounded-full bg-slate-100 px-2 py-0.5 text-[11px] text-slate-600">{u.role}</span>
            </button>
          ))}
          {rows.length === 0 && <p className="p-4 text-center text-sm text-slate-500">Aucun utilisateur.</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const ImpersonationBanner = () => {
  const { impersonatedName, stopImpersonation } = useAuth();
  if (!impersonatedName) return null;
  return (
    <div className="sticky top-0 z-50 flex items-center justify-center gap-3 bg-[#F26A1B] px-4 py-2 text-sm font-semibold text-white" data-testid="impersonation-banner">
      <Eye className="h-4 w-4" />Vous voyez l'application comme <b className="uppercase">{impersonatedName}</b> — vos actions sont faites en son nom.
      <button type="button" onClick={stopImpersonation} className="inline-flex items-center gap-1 rounded-md bg-white px-3 py-1 text-[#C2510F] hover:bg-orange-50" data-testid="impersonation-stop"><Undo2 className="h-4 w-4" />Revenir à mon compte</button>
    </div>
  );
};
